import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'src/utils/i18n'

import styles from '/styles/contacts.module.scss'

import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

import TemporaryDrawer from 'src/@core/components/contacts-info'
import toExcel from 'src/@core/components/to-excel'
import { useAndroidDevicePagedData } from 'src/hooks/useAndroidDevicePagedData'

import { useDispatch } from 'react-redux'
import Image from 'next/image'
import { setCurrentTab } from 'src/store/apps/Common'
import { pinyin } from 'pinyin-pro'
import ContentLoading from 'src/components/ContentLoading'

const getFirstLetter = name => {
  if (!name) return '#'

  const py = pinyin(name, {
    toneType: 'none',
    nonZh: 'remove'
  })

  const firstLetter = py.charAt(0)

  return /[a-zA-Z]/.test(firstLetter) ? firstLetter.toUpperCase() : '#'
}

const classifyContacts = contacts => {
  const map = {}
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('').forEach(key => {
    map[key] = []
  })

  contacts.forEach(item => {
    map[getFirstLetter(item.name)].push(item)
  })

  Object.values(map).forEach(items => {
    items.sort((a, b) => {
      const pyA = pinyin(a.name || '', { toneType: 'none' })
      const pyB = pinyin(b.name || '', { toneType: 'none' })

      return pyA.localeCompare(pyB)
    })
  })

  return Object.entries(map).map(([type, arr]) => ({ type, arr }))
}

const Contacts = () => {
  const { t } = useTranslation('common')

  const [Basic, setBasic] = useState(true)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const val = window.localStorage.getItem('Basic')
      setBasic(val == null || val == 0)
    }
  }, [])
  Basic == null || Basic == 0 ? true : false

  const childRef = useRef()

  const [initContacts, setInitContacts] = useState([])

  // 联系人信息
  const [userInfo, setUserInfo] = useState({ firstName: '', name: '' })

  // 联系人数组
  const [useContactsPeople, setContactsPeople] = useState([])
  const { context, data: contactRecords, loading: isLoading, loadNext } = useAndroidDevicePagedData({
    source: 'cloud',
    category: 'CONTACT',
    limit: 50
  })

  useEffect(() => {
    const grouped = classifyContacts(contactRecords)
    setInitContacts(grouped)
    setContactsPeople(grouped)
  }, [contactRecords])

  useEffect(() => {
    setUserInfo({ firstName: '', name: '' })
  }, [context?.requestKey])

  let getContactsInfo = info => {
    // 当前点击联系人信息
    setUserInfo({
      ...info,
      firstName: info.name,
      phones: [{ field: info.phone }]
    })

    // 打开抽屉
    childRef.current.toggleDrawerParent('right', true)
  }

  // 处理搜索联系人人
  const handleFilter = e => {
    let value = e.target.value

    if (value === '') {
      setContactsPeople(initContacts)

      return
    }

    // 搜索过滤

    let filterData = initContacts.map(item => {
      return {
        type: item.type,
        arr: item.arr.filter(children => {
          return children.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
        })
      }
    })
    setContactsPeople(filterData)
  }

  // 导出
  function formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  }

  // 处理导出数据

  const toexcel = () => {
    const th = ['name', 'phone', 'Email']
    const filterVal = ['name', 'phone', 'email']

    let dataSource = []

    for (let i = 0; i < initContacts.length; i++) {
      if (initContacts[i].arr.length > 0) {
        let data = initContacts[i].arr.map(item => {
          try {
            return {
              name: item.name,
              phone: item.phone,
              email: item.emailAddresses instanceof Array ? item.emailAddresses[0].field : ''
            }
          } catch (error) {
            return {
              name: '',
              number: '',
              email: ''
            }
          }
        })

        dataSource = dataSource.concat(data)
      }
    }
    var data = formatJson(filterVal, dataSource)

    toExcel({ th, data, fileName: 'export_contacts_data', fileType: 'xlsx', sheetName: 'sheet' })
  }

  const dom = useRef()
  const refs = useRef([])

  const addToRefs = el => {
    if (el && !refs.current.includes(el)) {
      refs.current.push(el)
      console.log(el.innerText, el.textContent, el.offsetTop)
    }
  }

  const jump = val => {
    for (const item of refs.current) {
      if (item.textContent === val) {
        dom.current.scrollTop = item.offsetTop
        console.log(item.offsetTop)
      }
    }
  }

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100) loadNext()
  }, [loadNext, scroll])

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentTab(t('Contact')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[20px] pb-[20px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative'>
      <div className='w-full text-right mb-[15px] px-[15px]'>
        <span
          className='text-[14px] text-[#007AFF] cursor-pointer'
          onClick={() => {
            toexcel()
          }}
        >
          {t('export_contacts')}
        </span>
      </div>
      <div className='w-full px-[15px]'>
        <TextField
          fullWidth
          className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]'
          size='small'
          onInput={e => {
            handleFilter(e)
          }}
          placeholder={t('Search Contacts')}
          sx={{
            '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
            '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
              </InputAdornment>
            )
          }}
        />
      </div>
      <div ref={dom} className='w-full flex flex-1 overflow-auto relative'>
        <div className='flex-1 px-[15px]'>
          {useContactsPeople.map(item => (
            <div key={item.type}>
              {item.arr.length > 0 ? (
                <dl className=''>
                  <dt
                    className='text-[15px] text-[#8A8A8D] font-[600] border-b border-[#E5E7EB] pt-[25px] pb-[5px]'
                    ref={addToRefs}
                  >
                    {item.type}
                  </dt>
                  <div className=''>
                    {item.arr &&
                      item.arr.map((children, i) => (
                        <dd
                          key={children.name + i}
                          className='py-[12px] border-b border-[#E5E7EB] text-[14px] font-[600] text-[#000000]'
                          onClick={() => {
                            getContactsInfo(children)
                          }}
                        >
                          <div className=''>
                            <span className=''>{children.name}</span>
                          </div>
                        </dd>
                      ))}
                  </div>
                </dl>
              ) : null}
            </div>
          ))}
        </div>
      </div>
      {/* 右侧字母 */}
      <div className='w-[15px] flex flex-col items-center justify-center absolute right-0 top-0 h-full pt-[99px]'>
        {[
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
          'G',
          'H',
          'I',
          'J',
          'K',
          'L',
          'M',
          'N',
          'O',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z',
          '#'
        ].map((item, i) => (
          <div key={i} className='text-[10px] text-[#007AFF] font-[600] cursor-pointer' onClick={() => jump(item)}>
            {item}
          </div>
        ))}
      </div>
      <TemporaryDrawer data={userInfo} ref={childRef} />
      {isLoading ? (
        <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
          <ContentLoading />
        </div>
      ) : null}
      {(initContacts.length > 0 || isLoading) ||
        <div className='text-center px-4 absolute inset-0 flex justify-center items-center pointer-events-none'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>}
    </div>
  )
}

export default Contacts
